import Decimal from "decimal.js";

type FormatNumberType = "number" | "currency" | "percent" | "stat";

const numberWithCents = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberWithoutCents = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

const percentWithCents = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentWithoutCents = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 0,
});

export const formatNumber = (
  value: number,
  type: FormatNumberType = "number",
  withOutCents = false,
): string | number => {
  value = Number(String(value).replace(/,/g, ""));
  if (isNaN(value)) value = 0;

  switch (type) {
    case "currency":
      return withOutCents
        ? numberWithoutCents.format(value)
        : numberWithCents.format(value);

    case "percent":
      return withOutCents
        ? percentWithoutCents.format(value)
        : percentWithCents.format(value);

    case "number":
      return new Decimal(value)
        .toDecimalPlaces(withOutCents ? 0 : 2, Decimal.ROUND_HALF_UP)
        .toNumber();

    case "stat":
      return numberWithoutCents.format(value);
  }
};

declare global {
  interface Window {
    formatNumber: typeof formatNumber;
  }
}

window.formatNumber = formatNumber;
